import { createSlice } from '@reduxjs/toolkit'

import { getInformations, getInformationsByFilteredTop } from './actions'

export const initialState: any = {
  information: {
    data: [],
    loading: false,
    error: null,
  },
  informationTop: {
    data: [],
    loading: false,
    error: null,
  },
}

const informationSlice = createSlice({
  name: 'information',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getInformations.pending, state => {
      state.information.loading = true
      state.information.error = null
    })
    builder.addCase(getInformations.fulfilled, (state, { payload }) => {
      state.information.loading = false
      state.information.data = payload
    })
    builder.addCase(getInformations.rejected, (state, { payload }) => {
      state.information.loading = false
      state.information.error = payload as null
    })
    builder.addCase(getInformationsByFilteredTop.pending, state => {
      state.informationTop.loading = true
      state.informationTop.error = null
    })
    builder.addCase(getInformationsByFilteredTop.fulfilled, (state, { payload }) => {
      state.informationTop.loading = false
      state.informationTop.data = payload
    })
    builder.addCase(getInformationsByFilteredTop.rejected, (state, { payload }) => {
      state.informationTop.loading = false
      state.informationTop.error = payload as null
    })
  },
})

export const { name, actions } = informationSlice

const informationReducer = informationSlice.reducer

export default informationReducer
